var drawstars = function(exam,global) {
    var currentQuestion = global.response.answers[global.questionIndex];
    if (currentQuestion.rating) {
        var stars = $(exam).find('.stars .star');
        $(stars).removeClass('highlight');
        for (var i = 0; i < currentQuestion.rating; i++ ) {
            $(stars[i]).addClass('highlight');
        }
    } else {
        $('.stars .star').removeClass('highlight');
    }
}

module.exports = drawstars;




//////////////////
// WEBPACK FOOTER
// ./src/drawstars.js
// module id = 47
// module chunks = 0